export const passwordValidation =
  /.*([0-9]|[!"#$%&'()*+,-./:;<=>?@^_`{|}~]).*$/;
